import { render, staticRenderFns } from "./modifiers_groups_filter.vue?vue&type=template&id=0f99b772&scoped=true&"
import script from "./modifiers_groups_filter.vue?vue&type=script&lang=js&"
export * from "./modifiers_groups_filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f99b772",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f99b772')) {
      api.createRecord('0f99b772', component.options)
    } else {
      api.reload('0f99b772', component.options)
    }
    module.hot.accept("./modifiers_groups_filter.vue?vue&type=template&id=0f99b772&scoped=true&", function () {
      api.rerender('0f99b772', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/modifiers/groups/choose/tabs/modifiers_groups_filter.vue"
export default component.exports